module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAK1JREFUeNpi+P//PwMZ2BCIHwHxbCBmBomRa8ib/wiwEGQYCwPpgAmKYSAOiL8xkWCAIRDvBuL7QOwKxB+Q5LRJ8c5bqFfOArEgEBsD8XsgvgbEEuSECbJhIDlxYgIbmyEwsBRZLbmGXIW5hJBB+Ay5hm4ILoMMSDUEm0FkGYJuENmGIBtEkSHIBuEzRIKYRAtjUGQIPoNIMgSEYbn/PVIGfADEXkD8gpQiASDAAKU5SwHWpH1kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/edit-btn.png
// module id = 1505
// module chunks = 0